"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMacroListResponse = void 0;

var _genericAsResultHeader = require("../../../../utils/generic-as-result-header");

var _modelBuilders = require("../../../../utils/model-builders");

var _BooleanAsNumber = require("../../../../types/BooleanAsNumber");

/*
  Sample XML Response:
    <ListMacroNamesResponse xmlns="http://www.aperio.com/webservices/">
        <ListMacroNamesResult>
            <ASResult>0</ASResult>
            <ASMessage/>
            <ASDetails/>
        </ListMacroNamesResult>
        <MacroArray>
            <Macro Id="4" Name="Aperio Positive Pixel Count Sample Macro" IsDefault="0" Incremental="0" AlgorithmLicenseId="" DataGroupName="DefaultMacro" FullName="Administrator" Version="1" CreatedByUserId="3" CreatedOn="8/24/2016 2:55:49 PM"/>
            <Macro Id="3" Name="IHC PR Breast Dako ClonePgR636 v1" IsDefault="0" Incremental="1" AlgorithmLicenseId="10015" DataGroupName="Default" FullName="Administrator" Version="1" CreatedByUserId="3" CreatedOn="8/24/2016 2:53:58 PM"/>
            <Macro Id="2" Name="IHC ER Breast Dako Clone1D5 v1" IsDefault="0" Incremental="1" AlgorithmLicenseId="10014" DataGroupName="Default" FullName="Administrator" Version="1" CreatedByUserId="3" CreatedOn="8/24/2016 2:53:58 PM"/>
            <Macro Id="1" Name="IHC HER2 Breast Dako HercepTest v1" IsDefault="0" Incremental="1" AlgorithmLicenseId="10010" DataGroupName="Default" FullName="Administrator" Version="1" CreatedByUserId="3" CreatedOn="8/24/2016 2:53:58 PM"/>
        </MacroArray>
    </ListMacroNamesResponse>
*/
var createMacroListResponse = function createMacroListResponse(raw) {
  var out = (0, _modelBuilders.parseModel)(raw, {
    result: {
      path: 'ListMacroNamesResult[0]',
      model: _genericAsResultHeader.genericAsResultHeader
    },
    response: {
      path: 'MacroArray[0].Macro',
      model: {
        id: {
          type: Number,
          path: '$.Id'
        },
        name: {
          type: String,
          path: '$.Name'
        },
        isDefault: {
          type: _BooleanAsNumber.BooleanAsNumber,
          path: '$.IsDefault'
        },
        isIncremental: {
          type: _BooleanAsNumber.BooleanAsNumber,
          path: '$.Incremental'
        },
        algorithmLicenseId: {
          type: Number,
          path: '$.AlgorithmLicenseId'
        },
        dataGroupName: {
          type: String,
          path: '$.DataGroupName'
        },
        fullName: {
          type: String,
          path: '$.FullName'
        },
        version: {
          type: Number,
          path: '$.Version'
        },
        createdByUserId: {
          type: Number,
          path: '$.CreatedByUserId'
        },
        createdOn: {
          type: Date,
          path: '$.CreatedOn'
        }
      }
    }
  });

  if (!out.response) {
    out.response = [];
  }

  return out;
};

exports.createMacroListResponse = createMacroListResponse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/macros/response-parsers/macro-list-response.js
// module id = 229
// module chunks = 0